import React, {useState} from 'react';
import {Avatar, Button, Card, Dropdown, Space, Spin, Tabs, Tag} from "antd";

import {LoginOutlined, MoreOutlined} from "@ant-design/icons";

import {useParams} from "react-router-dom";

import AdminLayout from "@/components/layout/admin/adminLayout";

import RandomImage from "@/lib/helper/randomImage";
import CopyMe from "@/lib/helper/copyMe";
import GenderComponent from "@/components/gender/GenderComponent";
import {MemberStatusEnum} from "@/lib/helper/enumType";
import toFaNumber from "@/lib/utils/number";

import {URLS} from "@/lib/urls";
import {prepareLBA} from "@/lib/services/tokenService";

import {useAuth} from "@/provider/AuthProvider";

import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

import {useApiAdminLoginByUser, useApiGetAdminMember, useApiUpdateAdminProfile} from "@/api/userAcademy";

import UploadCMP from "@/components/upload";
import RenderIf from "@/components/render-if";

import ChangeProfileModalSection from "@/pages/admin/member/[id]/_section/changeProfileModal";
import ChangeLocationModal from "@/pages/admin/member/[id]/_section/changeLocationModal";
import ChangeEducationModal from "@/pages/admin/member/[id]/_section/changeEducationModal";
import ChangeMobileModal from "@/pages/admin/member/[id]/_section/changeMobileModal";
import ChangeDocumentModal from "@/pages/admin/member/[id]/_section/changeDocumentModal";
import MemberTypeComponent from "@/components/member-type/MemberTypeComponent";
import ProfileTab from "@/pages/admin/member/[id]/_section/tabProfile";
import PermissionTab from "@/pages/admin/member/[id]/_section/tabPermission";

export default function AdminEditMember2() {

    const params = useParams();

    const {user: userLoginData} = useAuth();

    const [modalIdentify, setModalIdentify] = useState(false);
    const [modalLocation, setModalLocation] = useState(false);
    const [modalEducation, setModalEducation] = useState(false);
    const [modalDocuments, setModalDocuments] = useState(false);
    const [modalMobile, setModalMobile] = useState(false);

    const {
        data: user,
        isPending,
        isSuccess,
        refetch
    } = useApiGetAdminMember(params.id);

    const student = user?.data?.data;

    const {mutate: updateProfile} = useApiUpdateAdminProfile();

    const {
        mutate: loginByAnother,
        isPending: isPendingLoginByAnother
    } = useApiAdminLoginByUser();

    function handleLoginByAnother(userId) {

        loginByAnother(
            {user_id: userId},
            {
                onSuccess: (data) => {
                    prepareLBA();
                    window.open(
                        `/login-as?accessToken=${data?.data?.data?.access_token}`,
                        "_blank"
                    );
                },

                onError: (error) => {
                    ApiHandleErrorMessage(error);
                }
            }
        );
    }

    function updateProfileDoc(key, file) {

        let update = {};

        update[key] = file?.file?.response?.data?.id;

        updateProfile(update, {
            onSuccess: (res) => {

                refetch();

                ApiHandleSuccessMessage(res);
            },

            onError: (errors) => {
                ApiHandleErrorMessage(errors);
            },
        });
    }

    const actionItems = [
        {
            key: 'edit-profile',
            label: 'ویرایش اطلاعات هویتی',
            onClick: () => setModalIdentify(true)
        },

        {
            key: 'edit-location',
            label: 'ویرایش آدرس',
            onClick: () => setModalLocation(true)
        },

        {
            key: 'edit-education',
            label: 'ویرایش تحصیلات',
            onClick: () => setModalEducation(true)
        },

        {
            key: 'edit-mobile',
            label: 'ویرایش ارتباطات',
            onClick: () => setModalMobile(true)
        },

        {
            key: 'edit-documents',
            label: 'ویرایش مدارک',
            onClick: () => setModalDocuments(true)
        },
    ];

    const tabItems = [
        // {
        //     key: 'overview',
        //     label: 'نمای کلی',
        //     children: (
        //         <OverviewTab student={student}/>
        //     )
        // },

        {
            key: 'profile',
            label: 'پروفایل',
            children: (
                <ProfileTab
                    student={student}
                    setModalIdentify={setModalIdentify}
                    setModalDocuments={setModalDocuments}
                    setModalLocation={setModalLocation}
                    setModalMobile={setModalMobile}
                    updateProfileDoc={updateProfileDoc}
                />
            )
        },
        {
            key: 'permission',
            label: 'سطح دسترسی',
            children: (
                <PermissionTab student={student}/>
            )
        },
        // {
        //     key: 'academic',
        //     label: 'آموزشی',
        //     children: (
        //         <AcademicTab student={student}/>
        //     )
        // },
        //
        // {
        //     key: 'financial',
        //     label: 'مالی',
        //     children: (
        //         <FinancialTab student={student}/>
        //     )
        // },
        //
        // {
        //     key: 'support',
        //     label: 'پشتیبانی',
        //     children: (
        //         <SupportTab student={student}/>
        //     )
        // },
    ];

    return (
        <AdminLayout
            pageTitle={'نمایه عضو'}
            backTo={URLS.admin.members.list}
        >

            {isPending && (
                <Spin spinning={isPending}/>
            )}

            {isSuccess && (
                <div className="flex flex-col gap-4">

                    {/* ---------------- MODALS ---------------- */}

                    <ChangeProfileModalSection
                        openModal={modalIdentify}
                        onClose={() => setModalIdentify(false)}
                        onSubmit={() => {
                            setModalIdentify(false);
                            refetch();
                        }}
                        user={student}
                    />

                    <ChangeLocationModal
                        openModal={modalLocation}
                        onClose={() => setModalLocation(false)}
                        onSubmit={() => {
                            setModalLocation(false);
                            refetch();
                        }}
                        user={student}
                    />

                    <ChangeEducationModal
                        openModal={modalEducation}
                        onClose={() => setModalEducation(false)}
                        onSubmit={() => {
                            setModalEducation(false);
                            refetch();
                        }}
                        user={student}
                    />

                    <ChangeMobileModal
                        openModal={modalMobile}
                        onClose={() => setModalMobile(false)}
                        onSubmit={() => {
                            setModalMobile(false);
                            refetch();
                        }}
                        user={student}
                    />

                    <ChangeDocumentModal
                        openModal={modalDocuments}
                        onClose={() => setModalDocuments(false)}
                        onSubmit={() => {
                            setModalDocuments(false);
                            refetch();
                        }}
                        user={student}
                    />

                    {/* ---------------- HEADER ---------------- */}

                    <Card className="overflow-hidden" size={'small'}>

                        <div
                            className="h-36 rounded-xl relative overflow-hidden"
                            style={{
                                backgroundImage: `url(${RandomImage(student?.id)})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat'
                            }}
                        >

                            {/*<div className="absolute inset-0 bg-black/30"/>*/}

                        </div>

                        <div className="relative px-6 pb-4">

                            <div className="flex flex-wrap items-end justify-between gap-4 -mt-14">

                                <div className="flex items-end gap-4">

                                    <UploadCMP
                                        model={'avatar'}
                                        afterUploadFn={(f) => updateProfileDoc('avatar', f)}
                                        hideUploadText={true}
                                    >

                                        <Avatar
                                            size={110}
                                            src={student?.avatar ?? `/images/profile.jpg`}
                                            className="border-4 border-white shadow-lg"
                                        />

                                    </UploadCMP>

                                    <div className="pb-2">

                                        <div className="flex items-center gap-2 flex-wrap">

                                            <GenderComponent
                                                selfMode={true}
                                                text={student?.gender}
                                            />
                                            <h1 className="text-2xl font-bold m-0">

                                                {student?.firstname} {student?.lastname}

                                            </h1>


                                        </div>

                                        <Space wrap className="mt-2">

                                            <Tag color="">

                                                شماره پرونده:
                                                {' '}
                                                <CopyMe data={student?.code}>
                                                    {toFaNumber(student?.code)}
                                                </CopyMe>

                                            </Tag>

                                            <Tag color={MemberStatusEnum(student?.status, 'color')}>
                                                {MemberStatusEnum(student?.status)}

                                            </Tag>

                                            <MemberTypeComponent member={student}/>

                                        </Space>

                                    </div>

                                </div>

                                <div className="flex items-center gap-2 flex-wrap">

                                    <RenderIf condition={userLoginData?.permission === 'supervisor'}>

                                        <Button
                                            icon={<LoginOutlined/>}
                                            loading={isPendingLoginByAnother}
                                            onClick={() => handleLoginByAnother(student?.user_id)}
                                        >
                                            ورود به حساب
                                        </Button>

                                    </RenderIf>
                                    <RenderIf condition={false}>
                                        <Dropdown
                                            menu={{
                                                items: actionItems
                                            }}
                                        >

                                            <Button icon={<MoreOutlined/>}>
                                                عملیات
                                            </Button>

                                        </Dropdown>
                                    </RenderIf>


                                </div>

                            </div>

                        </div>

                    </Card>

                    {/* ---------------- TABS ---------------- */}

                    <Card>

                        <Tabs
                            defaultActiveKey="profile"
                            items={tabItems}
                        />

                    </Card>

                </div>
            )}

        </AdminLayout>
    );
}


/* -------------------------------------------------------------------------- */
/*                                   WIDGET                                   */
/* -------------------------------------------------------------------------- */

export const DetailProfileWidget = ({
                                        label,
                                        value,
                                        showIfValue = false
                                    }) => {

    if (showIfValue && !value) {
        return null;
    }

    return (
        <div className="flex items-start gap-2 flex-wrap">

            <span className="text-gray-500 min-w-[120px]">
                {label} :
            </span>

            <span className="font-medium break-all">
                {value ?? '-'}
            </span>

        </div>
    );
};